import { render } from "./multipleselect2.vue?vue&type=template&id=13c61191"
import script from "./multipleselect2.vue?vue&type=script&lang=js"
export * from "./multipleselect2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adi/Sites/yelp-ads/sweepstakes-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__